import { useTranslation as t } from '../../hooks/useTranslation';
import EpInfoCard from '../EpInfoCard';
import { EpInput } from '../EpInput';
import { EpModal, hideModal } from '../EpModal';

interface IEpShareEmailModal {
  sendMailFunc: () => void;
  setEmail: (arg: string) => void;
  translations: unknown;
}

export const EpShareEmailModal = ({
  sendMailFunc,
  setEmail,
  translations,
}: IEpShareEmailModal) => {
  return (
    <EpModal
      modalId="share-email-modal"
      modalTitle={t(translations, 'Share data via email')}
      modalType="default"
      modalSize="md"
      modalButtonList={[
        {
          buttonId: 'modal__button--close',
          buttonText: t(translations, 'Cancel'),
          buttonType: 'secondary-outline',
          buttonSize: 'md',
          isCloseButton: true,
        },
        {
          buttonId: 'modal__button--save',
          buttonText: t(translations, 'Send'),
          buttonType: 'primary',
          isCloseButton: false,
          buttonSize: 'md',
          buttonLeftIconName: 'SolidPaperPlane',
          buttonOnClickFunc: () => {
            sendMailFunc();
            hideModal('share-email-modal');
          },
        },
      ]}
    >
      <div style={{ height: 'max-content' }}>
        <EpInfoCard
          title={t(translations, 'Enviar os dados de acesso a notificação')}
          type={'filled'}
        >
          <p>
            {t(
              translations,
              'If you have not identified yourself in this notification, entering your email can be a great option to save this data to check the status of the notification in the future.',
            )}
          </p>
          <p>
            {t(
              translations,
              'The e-mail informed below will not be stored in our database nor associated with the notification.',
            )}
          </p>
        </EpInfoCard>

        <div>
          <label>
            {t(
              translations,
              'Enter the email you want to send the notification access data',
            )}
          </label>
          <EpInput
            inputId="share-email"
            inputName="share-email"
            inputSize="md"
            inputHasIcon
            inputIconName="SolidEnvelopSquare"
            inputPlaceholder="email@email.com"
            inputIsFullWidth
            onChange={({ target }) => setEmail(target.value)}
          />
        </div>
      </div>
    </EpModal>
  );
};
